var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wine-club-list", attrs: { id: "wineclub-list" } },
    [
      _vm.clubs.length > 0 && _vm.clubs[0] != null
        ? [
            _c("div", { staticClass: "container" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "club-list" },
                _vm._l(_vm.clubs, function (club) {
                  return _c("ClubContainer", {
                    key: club.id,
                    attrs: { club: club },
                  })
                }),
                1
              ),
            ]),
          ]
        : [_vm._m(1)],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("h1", [_vm._v("Our Wineclubs")]),
      _vm._v(" "),
      _c("h2", [_vm._v("Unbox. Uncork. Enjoy.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("h1", [_vm._v("There are currently no clubs to display.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }